import { useState } from "react";
import { ActionModal, FIELD_LABEL_CLASS, INPUT_CLASS } from "./ActionModal";

/**
 * Correct the wording of a logged fix or a blocked-on note — the only two
 * entries a human composed. Everything else in the thread is the machine
 * narrating what it did, and the server refuses to let a person put words in
 * its mouth.
 *
 * What it deliberately does not do is worth saying in the modal itself,
 * because both are easy to assume: it does not re-run anything (a correction
 * is not a new fix report), and it does not move the 7-day reminder clock (a
 * typo must not buy another week of quiet). The old wording is kept
 * server-side.
 */
export function EditEntryModal({
  kind,
  current,
  onSubmit,
  onClose,
  pending,
}: {
  kind: "fix-logged" | "note";
  current: string;
  onSubmit: (note: string) => void;
  onClose: () => void;
  pending?: boolean;
}) {
  const [note, setNote] = useState(current);
  const label = kind === "fix-logged" ? "logged fix" : "note";

  return (
    <ActionModal
      title={`Edit ${label}`}
      submitLabel="Save"
      onSubmit={() => onSubmit(note.trim())}
      onClose={onClose}
      pending={pending}
      disabled={!note.trim() || note.trim() === current}
    >
      <div>
        <label className={FIELD_LABEL_CLASS}>
          {kind === "fix-logged" ? "What was done" : "What this is blocked on"}
        </label>
        <textarea
          className={`${INPUT_CLASS} min-h-[110px]`}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          autoFocus
        />
      </div>
      <p className="text-xs text-gray-400">
        Wording only. Nothing re-runs, no problem changes state, and the 7-day
        reminder still counts from when this was first written. The previous
        wording is kept in the admin log.
      </p>
    </ActionModal>
  );
}
